const scheduleOptionsMap = {
  INSTALL_LATER:
    {
      name: 'Install Later Today',
      value: 'INSTALL_LATER',
      disabled: false,
    },
  INSTALL_ASAP:
    {
      name: 'Install ASAP',
      value: 'INSTALL_ASAP',
      disabled: false,
    },
  INSTALL_FORCE_RESTART:
    {
      name: 'Install Now (Force Update)',
      value: 'INSTALL_FORCE_RESTART',
      disabled: false,
    },
};

const modalMap = {
  INSTALL_LATER:
    {
      notificationTitle: 'Device Restart Required',
      notificationMessage: 'The Schedule OS Update command that JumpCloud leverages can have reliability issues on macOS Big Sur and Monterey and may require multiple attempts to complete.',
      modalBody: 'JumpCloud will send the update command and the device will attempt to update later today.',
      modalTitle: 'Schedule OS Update',
      modalCheckbox: false,
      modalCheckboxLabel: '',
      modalConfirmBtn: 'Schedule Update',
      subtitle: 'Are you sure you want to schedule this device to update to',
      subtitle2: 'later today',
      severity: 'sev2',
    },
  INSTALL_ASAP:
    {
      notificationTitle: 'Device Restart Required',
      notificationMessage: 'The Schedule OS Update command that JumpCloud leverages can have reliability issues on macOS Big Sur and Monterey and may require multiple attempts to complete.',
      modalBody: 'JumpCloud will send the update command and the device will attempt to update ASAP.',
      modalTitle: 'Schedule OS Update',
      modalCheckbox: false,
      modalCheckboxLabel: '',
      modalConfirmBtn: 'Schedule Update',
      subtitle: 'Are you sure you want to schedule this device to update to',
      subtitle2: 'ASAP',
      severity: 'sev2',
    },
  INSTALL_FORCE_RESTART:
    {
      notificationTitle: 'Device Restart Required',
      // eslint-disable-next-line quotes
      notificationMessage: "This update will immediately download and install on this device. The end-user will not be able to postpone this update. Data loss is possible.",
      modalBody: 'The device will be forced to restart during the update process. Updates can take around 30 minutes to complete.',
      modalTitle: 'Force OS Update',
      modalCheckbox: true,
      modalCheckboxLabel: 'I understand this action may cause the end-user to lose unsaved work.',
      modalConfirmBtn: 'Update Now',
      modalCustomBtn: true,
      subtitle: 'Are you sure you want to force this device to update to',
      subtitle2: '',
      severity: 'sev3',
    },
};

export default {
  modalMap,
  scheduleOptionsMap,
};
